module.exports = {
	"status": [
		{
			"id": 101,
			"desc": "BCMU #1 state",
			"type": "value",
			"decode": {
				"0": "normal",
				"1": "full",
				"2": "empty",
				"3": "standby",
				"4": "stop"
			}
		},
		{
			"id": 102,
			"desc": "BCMU #2 state",
			"type": "value",
			"decode": {
				"0": "normal",
				"1": "full",
				"2": "empty",
				"3": "standby",
				"4": "stop"
			}
		},
		{
			"id": 103,
			"desc": "BCMU #3 state",
			"type": "value",
			"decode": {
				"0": "normal",
				"1": "full",
				"2": "empty",
				"3": "standby",
				"4": "stop"
			}
		},
		{
			"id": 104,
			"desc": "BCMU #1 BMU states",
			"type": "bitfield",
			"decode": {
				"0": "bmu_1_fault",
				"1": "bmu_2_fault",
				"2": "bmu_3_fault",
				"3": "bmu_4_fault",
				"4": "bmu_5_fault",
				"5": "bmu_6_fault",
				"6": "bmu_7_fault",
				"7": "bmu_8_fault",
				"8": "bmu_9_fault",
				"9": "bmu_10_fault",
				"10": "bmu_11_fault",
				"11": "bmu_12_fault",
				"12": "bmu_13_fault",
				"13": "bmu_14_fault",
				"14": "bmu_15_fault",
				"15": "bmu_16_fault",
				"16": "bmu_17_fault",
				"17": "bmu_18_fault"
			}
		},
		{
			"id": 105,
			"desc": "BCMU #2 BMU states",
			"type": "bitfield",
			"decode": {
				"0": "bmu_1_fault",
				"1": "bmu_2_fault",
				"2": "bmu_3_fault",
				"3": "bmu_4_fault",
				"4": "bmu_5_fault",
				"5": "bmu_6_fault",
				"6": "bmu_7_fault",
				"7": "bmu_8_fault",
				"8": "bmu_9_fault",
				"9": "bmu_10_fault",
				"10": "bmu_11_fault",
				"11": "bmu_12_fault",
				"12": "bmu_13_fault",
				"13": "bmu_14_fault",
				"14": "bmu_15_fault",
				"15": "bmu_16_fault",
				"16": "bmu_17_fault",
				"17": "bmu_18_fault"
			}
		},
		{
			"id": 106,
			"desc": "BCMU #3 BMU states",
			"type": "bitfield",
			"decode": {
				"0": "bmu_1_fault",
				"1": "bmu_2_fault",
				"2": "bmu_3_fault",
				"3": "bmu_4_fault",
				"4": "bmu_5_fault",
				"5": "bmu_6_fault",
				"6": "bmu_7_fault",
				"7": "bmu_8_fault",
				"8": "bmu_9_fault",
				"9": "bmu_10_fault",
				"10": "bmu_11_fault",
				"11": "bmu_12_fault",
				"12": "bmu_13_fault",
				"13": "bmu_14_fault",
				"14": "bmu_15_fault",
				"15": "bmu_16_fault",
				"16": "bmu_17_fault",
				"17": "bmu_18_fault"
			}
		},
		{
			"id": 107,
			"desc": "BCMU #1 alarm level 1",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_warning",
				"1": "totalvol_high_voltage_warning",
				"2": "charge_over_current_warning",
				"3": "cell_low_voltage_warning",
				"4": "totalvol_low_voltage_warning",
				"5": "discharge_over_current_warning",
				"6": "cell_charge_high_temperature_warning",
				"7": "cell_charge_low_temperature_warning",
				"8": "low_soc_warning",
				"12": "system_low_insulation_warning",
				"13": "high_soc_warning",
				"14": "cell_discharge_high_temperature_warning",
				"15": "cell_discharge_low_temperature_warning"
			}
		},
		{
			"id": 108,
			"desc": "BCMU #2 alarm level 1",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_warning",
				"1": "totalvol_high_voltage_warning",
				"2": "charge_over_current_warning",
				"3": "cell_low_voltage_warning",
				"4": "totalvol_low_voltage_warning",
				"5": "discharge_over_current_warning",
				"6": "cell_charge_high_temperature_warning",
				"7": "cell_charge_low_temperature_warning",
				"8": "low_soc_warning",
				"12": "system_low_insulation_warning",
				"13": "high_soc_warning",
				"14": "cell_discharge_high_temperature_warning",
				"15": "cell_discharge_low_temperature_warning"
			}
		},
		{
			"id": 109,
			"desc": "BCMU #3 alarm level 1",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_warning",
				"1": "totalvol_high_voltage_warning",
				"2": "charge_over_current_warning",
				"3": "cell_low_voltage_warning",
				"4": "totalvol_low_voltage_warning",
				"5": "discharge_over_current_warning",
				"6": "cell_charge_high_temperature_warning",
				"7": "cell_charge_low_temperature_warning",
				"8": "low_soc_warning",
				"12": "system_low_insulation_warning",
				"13": "high_soc_warning",
				"14": "cell_discharge_high_temperature_warning",
				"15": "cell_discharge_low_temperature_warning"
			}
		},
		{
			"id": 110,
			"desc": "BCMU #1 alarm level 2",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 111,
			"desc": "BCMU #2 alarm level 2",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 112,
			"desc": "BCMU #3 alarm level 2",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 119,
			"desc": "BCMU #1 alarm level 3",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 120,
			"desc": "BCMU #2 alarm level 3",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 121,
			"desc": "BCMU #3 alarm level 3",
			"type": "bitfield",
			"decode": {
				"0": "cell_high_voltage_alarm",
				"1": "totalvol_high_voltage_alarm",
				"2": "charge_over_current_alarm",
				"3": "cell_low_voltage_alarm",
				"4": "totalvol_low_voltage_alarm",
				"5": "discharge_over_current_alarm",
				"6": "cell_charge_high_temperature_alarm",
				"7": "cell_charge_low_temperature_alarm",
				"8": "low_soc_alarm",
				"12": "system_low_insulation_alarm",
				"13": "high_soc_alarm",
				"14": "cell_discharge_high_temperature_alarm",
				"15": "cell_discharge_low_temperature_alarm"
			}
		},
		{
			"id": 113,
			"desc": "BAU PCS communication",
			"type": "bitfield",
			"decode": {
				"0": "bau_pcs_communication_fault"
			}
		},
		{
			"id": 114,
			"desc": "BAU BCMU communication",
			"type": "bitfield",
			"decode": {
				"0": "bau_bcmu_communication_fault"
			}
		},
		{
			"id": 115,
			"desc": "BAMS state",
			"type": "bitfield",
			"decode": {
				"0": "bams_fault"
			}
		},
		{
			"id": 116,
			"desc": "BCMU #1 contactor state",
			"type": "bitfield",
			"decode": {
				"1": "contactor_open"
			}
		},
		{
			"id": 117,
			"desc": "BCMU #2 contactor state",
			"type": "bitfield",
			"decode": {
				"1": "contactor_open"
			}
		},
		{
			"id": 118,
			"desc": "BCMU #3 contactor state",
			"type": "bitfield",
			"decode": {
				"1": "contactor_open"
			}
		},
		{
			"id": 201,
			"desc": "Inverter #1 alarm code",
			"type": "raw"
		},
		{
			"id": 202,
			"desc": "Inverter #2 alarm code",
			"type": "raw"
		},
		{
			"id": 203,
			"desc": "Inverter #3 alarm code",
			"type": "raw"
		},
		{
			"id": 204,
			"desc": "Inverter #1 fault code",
			"type": "raw"
		},
		{
			"id": 205,
			"desc": "Inverter #2 fault code",
			"type": "raw"
		},
		{
			"id": 206,
			"desc": "Inverter #3 fault code",
			"type": "raw"
		},
		{
			"id": 208,
			"desc": "Inverter #1 state",
			"type": "bitfield",
			"decode": {
				"0": "ready_switch_on",
				"1": "ready",
				"2": "operation_enable",
				"3": "fault_present",
				"4": "alarm_present"
			}
		},
		{
			"id": 209,
			"desc": "Inverter #2 state",
			"type": "bitfield",
			"decode": {
				"0": "ready_switch_on",
				"1": "ready",
				"2": "operation_enable",
				"3": "fault_present",
				"4": "alarm_present"
			}
		},
		{
			"id": 210,
			"desc": "Inverter #3 state",
			"type": "bitfield",
			"decode": {
				"0": "ready_switch_on",
				"1": "ready",
				"2": "operation_enable",
				"3": "fault_present",
				"4": "alarm_present"
			}
		},
		{
			"id": 211,
			"desc": "PLC status word 1",
			"type": "bitfield",
			"decode": {
				"0": "inhibit_inverter3_discharge",
				"3": "pcs_system_starting",
				"4": "pcs_system_start_finish",
				"5": "pcs_system_stopping",
				"6": "pcs_system_stop_finish",
				"7": "ems_heart_beat_signal_fault",
				"8": "system_alarm_or_fault_present",
				"10": "remote_control",
				"11": "inhibit_inverter1_charge",
				"12": "inhibit_inverter1_discharge",
				"13": "inhibit_inverter2_charge",
				"14": "inhibit_inverter2_discharge",
				"15": "inhibit_inverter3_charge"
			}
		},
		{
			"id": 212,
			"desc": "PLC status word 2",
			"type": "bitfield",
			"decode": {
				"8": "pcs_device_ready_for_switch_on",
				"9": "pcs_device_ready_for_operation",
				"10": "pcs_device_operation_enabled",
				"11": "pcs_device_fault_present",
				"12": "pcs_device_alarm_present"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/constants/alarms.json
// module id = 148
// module chunks = 0